"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iDependencies = void 0;
var _dependenciesComplexClassGenerated = require("./dependenciesComplexClass.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var iDependencies = exports.iDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated.ComplexDependencies,
  createI: _factoriesAny.createI
};